import { Event } from '@/modules/tracking/types'

export default class ApplicationHeaderEvent extends Event {
  static readonly ProductComparison = new ApplicationHeaderEvent('Produktvergleich')
  static readonly Logo = new ApplicationHeaderEvent('Logo angeklickt')
  static readonly Cart = new ApplicationHeaderEvent('Einkaufswagen')
  static readonly Profile = new ApplicationHeaderEvent('Mein Profil')
  static readonly Logout = new ApplicationHeaderEvent('Ausloggen')
  static readonly ProductsMenuItem = new ApplicationHeaderEvent('Produkte')
  static readonly AppleCtoFinderMenuItem = new ApplicationHeaderEvent('Apple CTO-Finder')
  static readonly CollectionsMenuItem = new ApplicationHeaderEvent('Sammlungen')
  static readonly QuotesMenuItem = new ApplicationHeaderEvent('Angebote')
  static readonly OrdersMenuItem = new ApplicationHeaderEvent('Bestellungen')
  static readonly MyCompanyMenuItem = new ApplicationHeaderEvent('Meine Firma')
  static readonly RegisterMenuItem = new ApplicationHeaderEvent('Registrieren')
  static readonly LoginMenuItem = new ApplicationHeaderEvent('Login')
  static readonly BackToPlatformMenuItem = new ApplicationHeaderEvent('Zurück zu ITscope')
  static readonly InviteColleagues = new ApplicationHeaderEvent('Kollegen eingeladen')

  constructor(action: string, label?: string) {
    super('Anwendungsheader', action, label ?? '')
  }
}
